import { ISubscriptionDetailsState } from "./model";
import { createFeatureSelector, createSelector } from "@ngrx/store";
import { SUBSCRIPTION_DETAILS_FEATURE_KEY } from "./reducer";

export const subscriptionDetailsFeatureState = createFeatureSelector<ISubscriptionDetailsState>(
    SUBSCRIPTION_DETAILS_FEATURE_KEY
);

export const selectSubscription = createSelector(subscriptionDetailsFeatureState, (state) => state);

export const selectIsLoading = createSelector(subscriptionDetailsFeatureState, (state) => state.loading);

export const selectCreditCard = createSelector(subscriptionDetailsFeatureState, (state) => state.customer?.creditCard);

export const isEditingCreditCard = createSelector(
    subscriptionDetailsFeatureState,
    (state) => state.isEditingCreditCard
);

export const billings = createSelector(subscriptionDetailsFeatureState, (state) => state.billings);

export const isLoadingActiveBillings = createSelector(
    subscriptionDetailsFeatureState,
    (state) => state.loadingActiveBillings
);
